var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 435.68 415.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:#223c72;}.cls-5{fill:#efebe7;}.cls-6{fill:#ef3827;}.cls-7{fill:#303f66;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.68,0C129.05,0,48.46,60.11,26.21,150,0,255.88,64.57,362.92,170.41,389.1s212.88-38.36,239.08-144.21S371.14,32,265.28,5.83A198,198,0,0,0,217.69,0h0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -3243.33,
    cy: 2264.03,
    r: 1,
    gradientTransform: "matrix(197.47, 0, 0, -197.47, 640670.99, 447271.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f9f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#e9e6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#cfc8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6aba1"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "english") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 435.68,
    height: 415.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.21,150C52.4,44.17,159.44-20.37,265.28,5.83S435.68,139,409.49,244.89,276.27,415.3,170.41,389.1,0,255.88,26.21,150"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M357.9,58.27l-79.39,52.92V9.6c-4.34-1.39-8.74-2.66-13.23-3.77A196.44,196.44,0,0,0,156.67,9.75V111.2L77.59,58.49a196.19,196.19,0,0,0-42.82,65.08l20.94,14H29.76q-2,6.15-3.55,12.51a196.47,196.47,0,0,0,4.15,109.33H56.23L35.51,273.18A198.49,198.49,0,0,0,79,337.81L156.67,286v99.13q6.75,2.2,13.74,3.94a196.51,196.51,0,0,0,108.1-3.75V286l78,52a196.24,196.24,0,0,0,43.57-64.56l-21.15-14.09h26.38q2.34-7.11,4.17-14.48A196.64,196.64,0,0,0,406,137.53H379.46l21.36-14.23a198.28,198.28,0,0,0-42.92-65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.3,137.53,53,88.77a195.06,195.06,0,0,0-13.18,23.3l38.27,25.46ZM382.4,88.39a198,198,0,0,0-16.26-21.27l-87.63,58.27v12.14h30ZM53.53,306.9a197.82,197.82,0,0,0,16.3,21.22l86.84-57.75v-11H125Zm358.74-144H253.13V3.23a196.33,196.33,0,0,0-71.09,0V162.9H23.48A196.29,196.29,0,0,0,23.79,234H182V391.6a196.18,196.18,0,0,0,71.09.15V234H411.86a196.33,196.33,0,0,0,.41-71.06M310.21,259.37l71.85,47.77a194.78,194.78,0,0,0,13.3-23.22l-36.93-24.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M278.51,30.15h0V43a22.93,22.93,0,0,0,1.18-6.89,14.4,14.4,0,0,0-1.18-5.92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.7525787e47acd9276364a3b77c7280b0.svg";
export { ForwardRef as ReactComponent };